import { lStorage, lStorageKeys } from '../helpers/lStorage';
import Cookies from './cookies';

export function authHeader() {
    // return authorization header with jwt token
    let userToken = Cookies.get(lStorageKeys.AUTH_ACCESS_TOKEN);

    if (userToken) {
        return { 'Authorization': 'Bearer ' + userToken };
    } else {
        return {};
    }
}
